import { createContext, ReactNode, useContext } from 'react';
import { OptionsGroup } from './OptionsGroup';
import styled from 'styled-components';
import { colors, s4, s8 } from '@ardoq/design-tokens';
import { ViewIds } from '@ardoq/api-types';
import { SettingsConfig } from '@ardoq/view-settings';
import type { I18nLocale } from '@ardoq/i18n';

export interface SettingsBarProps {
  viewId: ViewIds;
  leftMenu: SettingsConfig[];
  rightMenu: SettingsConfig[];
  title?: string;
  customToolbarStyles?: React.CSSProperties;
  i18nLocale: I18nLocale;
}

const Toolbar = styled.div`
  border-bottom: 1px solid ${colors.grey200};
  display: flex;
  align-items: center;
  min-height: 32px;
  padding: ${s4} ${s8};
  background-color: ${colors.white950};

  @media print {
    display: none !important;
  }
`;

const OptionsGroupContainer = styled.div`
  display: flex;
  align-items: center;
`;

const LeftGroup = styled(OptionsGroupContainer)`
  flex: 1 1 auto;
`;

const RightGroup = styled(OptionsGroupContainer)``;

const SettingsBarBottomSlot = createContext<ReactNode>(null);

const SettingsBar = ({
  viewId,
  leftMenu,
  rightMenu,
  customToolbarStyles,
  i18nLocale,
}: SettingsBarProps) => {
  const bottomSlot = useContext(SettingsBarBottomSlot);

  return (
    <>
      <Toolbar
        data-click-namespace={`${viewId} view modifiers`}
        style={customToolbarStyles}
      >
        <LeftGroup aria-label="view modifiers">
          <OptionsGroup
            viewId={viewId}
            options={leftMenu}
            i18nLocale={i18nLocale}
          />
        </LeftGroup>
        <RightGroup aria-label="view actions">
          <OptionsGroup
            viewId={viewId}
            options={rightMenu}
            i18nLocale={i18nLocale}
          />
        </RightGroup>
      </Toolbar>
      {bottomSlot}
    </>
  );
};

export { SettingsBar, SettingsBarBottomSlot };
